import React, { Component } from 'react'
import "../../css/CalendarView.scss";
import { isEqual } from 'lodash'
import { FULL_MONTHS } from '../../constants/Constant';
import moment from 'moment';
import { reverseTimezoneOffset,scrollTo, scrollToError } from '../../managers/common/CommonUtil';
import {DKLine} from 'deskera-ui-library';
import TimesheetUtils from '../timesheet/TimesheetUtils';
import { CALENDAR_VIEW } from '../timesheet/TimesheetConstants';
const time = new Date().toString()?.match(/GMT\+[0-9]+/) && new Date().toString()?.match(/GMT\+[0-9]+/).length !=0 ? new Date().toString()?.match(/GMT\+[0-9]+/)[0]:""
const AM_HOURS = [{ title: '12 AM', format: '0' }, { title: '1 AM', format: '1' }, { title: '2 AM', format: '2' }, { title: '3 AM', format: '3' }, { title: '4 AM', format: '4' }, { title: '5 AM', format: '5' }, { title: '6 AM', format: '6' }, { title: '7 AM', format: '7' }, { title: '8 AM', format: '8' }, { title: '9 AM', format: '9' }, { title: '10 AM', format: '10' }, { title: '11 AM', format: '11' }];
const PM_HOURS = [{ title: '12 PM', format: '12' }, { title: '1 PM', format: '13' }, { title: '2 PM', format: '14' }, { title: '3 PM', format: '15' }, { title: '4 PM', format: '16' }, { title: '5 PM', format: '17' }, { title: '6 PM', format: '18' }, { title: '7 PM', format: '19' }, { title: '8 PM', format: '20' }, { title: '9 PM', format: '21' }, { title: '10 PM', format: '22' }, { title: '11 PM', format: '23' }];

class DayViewCalender extends Component {
    interval;
    timeLineHeight = 40;
    constructor(props) {
        super(props)
        this.state = {
            presentDay: this.props?.dateToShow
        }
    }
    componentDidMount() {
        setTimeout(()=>{
            scrollTo(document.getElementById(moment().format("h A")))

        },500)
        this.interval = setInterval(()=>{
            this.setState({
                ...this.state
            })
        },1000)
    }
    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps?.monthAndYear, this.props?.monthAndYear)) {
            const { month, year } = this.getMonthAndYearFromString(nextProps?.monthAndYear);
            const index = FULL_MONTHS.findIndex(mon => mon === month);

            if (nextProps?.prevButtonTapped) {
                const date = new Date(year, index, 0, 0, 0);
                this.setState({ presentDay: date });
            } else if (nextProps?.nextButtonTapped) {
                const date = new Date(year, index, 1, 0, 0);
                this.setState({ presentDay: date });
            }
        }
        if (nextProps?.prevButtonTapped) {
            this.prevClick();
        } else if (nextProps?.nextButtonTapped) {
            this.nextClick();
        } else if (nextProps?.todayTapped) {
            this.setState({ presentDay: new Date() })
        }
    }
    componentWillUnmount() {
        if(this.interval) {
            clearInterval(this.interval)
        }
    }

    getMonthAndYearFromString = (monthYearString) => {
        const splittedArray = monthYearString?.split(' ');
        return { month: splittedArray?.[0], year: splittedArray?.[1] }
    }

    nextClick = () => {
        let nextDay = new Date(new Date(this.state.presentDay).setDate(new Date(this.state.presentDay).getDate() + 1));
        this.setState({ presentDay: nextDay }, () => {
            this.props?.nextDay(new Date(nextDay))
        });
    }

    prevClick = () => {
        let prevDay = new Date(new Date(this.state.presentDay).setDate(new Date(this.state.presentDay).getDate() - 1));
        this.setState({ presentDay: prevDay }, () => {
            this.props?.prevDay(new Date(prevDay))
        });
    }

    isTaskDate(task, hour, date) {
        const day = (date);
        const taskFromDate = new Date(moment(task.fromDate).format());
        const taskToDate = new Date(moment(task.toDate).format());
        let tFromDate = `${taskFromDate.getDate()}/${taskFromDate.getMonth()+1}/${taskFromDate.getFullYear()}`;
        let tToDate = `${taskToDate.getDate()}/${taskToDate.getMonth()+1}/${taskToDate.getFullYear()}`;
        let currentDate = `${day.getDate()}/${day.getMonth()+1}/${day.getFullYear()}`
        let isBetWeen = (moment(currentDate,'DD/MM/YYYY').isBetween(moment(tFromDate,'DD/MM/YYYY'),moment(tToDate,'DD/MM/YYYY')))
        let isSameToDate = (moment(currentDate,'DD/MM/YYYY').isSame(moment(tToDate,'DD/MM/YYYY')))
        
        return (
            (  
                taskFromDate.getHours() == hour.format
                && taskFromDate.getDate() == day.getDate()
                && taskFromDate.getMonth() == day.getMonth()
                && taskFromDate.getFullYear() == day.getFullYear() 
            )
            //Note: will use leter ||(
            //         (
            //             (isBetWeen && hour.format === '0') 
            //             || (isSameToDate && hour.format === '0')
            //         ) &&
            //         (
            //             taskFromDate.getDate() != day.getDate()
            //         )
            //     )
            );
    }

    renderTasks = (date, hour) => {
        return this.props?.tasks?.map((task) => {
            if (this.isTaskDate(task, hour, date)) {
                return (
                    <div className="z-index-1" onClick={(e) => { e.stopPropagation(); this.props.onShowTask(task); }}>
                        {this.props?.taskRenderer(task,CALENDAR_VIEW.DAY,this.deleteEntry,date,this.onSubmit)}
                    </div>
                );
            }
        });
    }
    deleteEntry =(data)=>{
        if(this.props?.deleteEntry) {
            this.props.deleteEntry(data)
        }
    }
    onSubmit = (data) => {
        if(this.props?.onSubmit) {
            this.props.onSubmit(data)
        }
    }
    render() {
        return (
            <div className="">
                <table className="parent-width bg-white" >
                <thead className="">
                        <tr className="pt-l">
                            <th style={{ width: "108px" }}></th>
                            <th style={{ fontWeight: "500" }}>
                                <div className="flex column p-s justify-content-center align-items-start" >
                                    <div className='column justify-content-center align-items-center'>
                                        <div className="fs-l text-gray2">
                                            {new Date(this.state.presentDay).toLocaleString("en", { weekday: "long" }).substring(0, 3)}
                                        </div>
                                        <div className="bg-light-app fs-xl p-m" style={{ borderRadius: "50%", minHeight:24, minWidth:24 }}>
                                            {new Date(this.state.presentDay).toLocaleString("en-US", { day: "2-digit" })}
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody id="calendar-body">
                        <tr>
                            <td className="text-gray fs-s text-align-right pr-s" id={time} key={time} style={{ border: "none" }}>
                                {time}
                            </td>
                            <td className="d-flex  cursor-hand position-relative justify-content-start"
                                style={{ height: `${this.timeLineHeight}px`, borderRight: "none", borderBottom: "1px solid gainsboro", borderLeft: "1px solid gainsboro" }}
                                onClick={(e) => {
                                    // this.props?.onAddTask(e, new Date(this.state.presentDay), time);
                                }}
                            >
                                {this.renderTasks(new Date(this.state.presentDay), time)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            
            <div className="parent-width parent-height column border-box bg-white border-radius-s show-scroll-bar align-self-start shadow-s display-only-web pb-m calendar-view" id="calender-wrapper" style={{height:'calc(100vh - 450px)',overflow:'scroll'}}>
                <table className="table parent-width p-m pb-l" id="calendar" ref={this.calenderRef}>
                <thead className="">
                        <tr className="pt-l">
                            <th className="border-none" style={{ width: "100px" }}></th>
                            <th style={{ fontWeight: "500" }}>
                                
                            </th>
                        </tr>
                    </thead>
                    <tbody id="calendar-body">
                        {[...AM_HOURS, ...PM_HOURS].map((hour) => {
                            return (
                                <tr>
                                    <td className="text-gray fs-s text-align-right pr-s" id={hour.title} key={hour.title} style={{ border: "none", position:"relative", top:-22 }}>
                                        {hour.title}
                                    </td>
                                    <td className="d-flex  cursor-hand position-relative justify-content-start"
                                        style={{ height: `${this.timeLineHeight}px`, borderRight: "none" }}
                                        onClick={(e) => {
                                            this.props?.onAddTask(e, new Date(this.state.presentDay), hour);
                                        }}
                                    >
                                        {(moment().format("h A") === hour.title && moment().date() === new Date(this.state.presentDay).getDate()) &&
                                            <div className="d-flex">
                                                <div className="bg-red p-xs border-radius-m z-index-2" style={{position:'absolute', top: TimesheetUtils.getCurrentTimePosistion(this.timeLineHeight)-3 , left:-2}}></div>
                                                <DKLine className="bg-red z-index-2" style={{
                                                position: 'absolute',
                                                height:2,
                                                top: parseFloat(TimesheetUtils.getCurrentTimePosistion(this.timeLineHeight))
                                            }} />
                                            </div>
                                        }
                                        {this.renderTasks(new Date(this.state.presentDay), hour)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            </div>
        );
    }
}

export default DayViewCalender;
